const initialState = {
    userInfo: {},
  };
  const userInfoReducer = (state = initialState, action) => {
    switch (action.type) {
      case "USERS_INFO":
        return { ...state, userInfo: action.payload };
      default:
        return state;
    }
  };
  
  export default userInfoReducer;
  